import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import { Row, Col } from "antd";
import Detail from "./detail";
import PatentRatings from "./patent-ratings";
import PatentFullLanguage from "./full-language";
import PatentFamily from "./family";
import Citations from "./citations";
import RelatedCases from "./related-cases";
import PatentNotFound from "./patent-not-found";
import OppositionDocs from "./opposition-docs";
import PatentChat from "./patent-chat";
import LoadingWrapper from "../../common/loading-wrapper";
import ZendeskNewRequestLink from "../../common/links/zendesk-new-request-link";
import { toGooglePatentLink, toUsptoPatentPdfLink, toPriorArtLink } from "../../../helpers/converters";
import { getPatentDetail } from "../../../services/api-patents";
import { PUBLIC_URL } from "../../../config";
import { withRouter } from "react-router";

const styles = {
  body: {
    width: "100%",
    padding: 30,
    position: 'relative'
  },
  verticalGutter: {
    marginTop: 16
  },
  chatContainer: {
    position: "fixed",
    zIndex: 1000
  },
};

const trimXMLTags = val => (val ? val.trim().replace(/<\/?[^>]+(>|$)/g, "") : "");

class PatentDetail extends Component {
  state = {
    loading: true,
    assets: {},
  };

  componentDidMount() {
    this._isMounted = true;
    this._getPatentAssets();
  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.params.patentnum !== this.props.params.patentnum) {
      this._getPatentAssets();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { assets, loading } = this.state;
    const { patentnum } = this.props.params;
    const isPatentLoaded = assets.publication_number ? true : false;
    const publicURL = PUBLIC_URL + decodeURI(this.props.router.location.pathname);
    const helmet = {
      title: isPatentLoaded ? `${assets.publication_number} - ${assets.title}` : patentnum,
      meta: [
        {
          name: "keywords",
          content: "Patent,Patent Description,Patent Claims,Patent Figures,Patent Citations,Patent Ratings,Patent Litigation"
        },
        {
          name: "description",
          content: isPatentLoaded ? `${trimXMLTags(assets.abstract)}` : ""
        }
      ],
      link: [
        {
          rel: "canonical",
          href: isPatentLoaded ? encodeURI(publicURL.replace(`${patentnum}`, assets.publication_number)) : encodeURI(publicURL)
        }
      ]
    };
    return (
      <div style={styles.body} key={this.props.params.patentnum} ref={(container) => { this.container = container; }}>
        <Helmet {...helmet} />
        <LoadingWrapper loading={loading}>
          {assets.publication_number ? (
            <Fragment>
              <h2>
                {`${assets.publication_number} - ${assets.title}`}
                {toGooglePatentLink(assets.publication_number)}
                {assets.country === "US" ? toUsptoPatentPdfLink(assets.grant_number) : undefined}
                {assets.country === "US" ? toPriorArtLink(assets.publication_number) : undefined}
                <ZendeskNewRequestLink
                  text="Report Error"
                  subjectPrefix="Correction needed for page"
                  className="hidden-sm"
                  style={{
                    float: "right",
                    fontWeight: 400,
                    fontSize: "0.7em"
                  }}
                />
                <div style={styles.chatContainer}>
                  <PatentChat
                    assets={this.state.assets}
                    className="hidden-patty"
                  />
                </div>
              </h2>
              <div style={styles.verticalGutter}>
                <Detail data={assets} />
              </div>
              <Row gutter={16}>
                <Col span={24} lg={12} xl={10} style={styles.verticalGutter}>
                  <PatentRatings data={assets} />
                </Col>
                <Col span={24} lg={12} xl={14} style={styles.verticalGutter}>
                  <PatentFamily data={assets} />
                </Col>
              </Row>
              <div style={styles.verticalGutter}>
                <PatentFullLanguage data={assets} />
              </div>
              <div style={styles.verticalGutter}>
                <Citations data={assets} />
              </div>
              <div style={styles.verticalGutter}>
                <RelatedCases data={assets} />
              </div>
              <div style={styles.verticalGutter}>
                <OppositionDocs data={assets} />
              </div>
            </Fragment>
          ) : (
            <PatentNotFound />
          )}
        </LoadingWrapper>
      </div>
    );
  }

  _handleChatButtonClick = () => {
    this.setState(() => ({
      isChatButtonVisible: false,
      isChatVisible: true,
      minimized: false
    }));
  };

  _getPatentAssets = () => {
    getPatentDetail(this.props.params.patentnum, true)
      .then(resp => {
        if (resp && resp["_found"]) {
          if (this._isMounted)
            this.setState({
              loading: false,
              assets: resp["_source"]
            });
        } else {
          throw "Patent not found.";
        }
      })
      .catch(() => {
        if (this._isMounted) this.setState({ assets: {}, loading: false });
      });
  };
}

export default withRouter(PatentDetail);